import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='claims-intro'
      disableBottomPadding
      // content
      headingText={<>We&#39;re here <WidowBlock>for you</WidowBlock></>}
      introContent={(
        <Typography disableBottomPadding>
          We made you a promise that you can count on us whenever you need us, and we&#39;re here for you now. We know this is likely a difficult time, so whether you&#39;re dealing with a death, accident, or illness, we&#39;ll make the claims process as smooth and swift as possible. We understand how overwhelming this can all be, and we&#39;re here to help. Whenever you&#39;re ready.
        </Typography>
      )}
    />
  );
};
